// MainLayout.js
import "./MainLayout.scss";
import Footer from "../../components/general/footer/Footer";
import CartDrawer from "../../components/general/cart/cart_drawer/CartDrawer";
import WhatsAppButton from "../../components/Whats_app_button/WhatsAppButton";
import AmazonNavbar from "../../components/general/navbar/AmazonNavbar";
import { useWishlist } from "../../context/WishlistContext";
import { useAuth } from "../../context/AuthContext";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

export default function MainLayout() {
  const { syncWishlist } = useWishlist();
  const authContext= useAuth();
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  const loadWishlist= async ()=>{
      await syncWishlist();
  }

  useEffect(()=>{
    if(authContext?.user && authContext?.user?.active){
      loadWishlist();
    }
  }, [authContext?.user]);

  return (
    <main className="main-layout">
      <AmazonNavbar isHomePage={isHomePage} />
      <WhatsAppButton />
      <CartDrawer />
      <Outlet />
      <Footer />
    </main>
  );
}